var _desc, _circle, _circle2, _text, _text2, _text3, _text4, _line, _line2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Clock Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Church-themed clock icon")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 40,
    fill: "#D4C4A0",
    stroke: "#C8B59B",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 35,
    fill: "none",
    stroke: "#C8B59B",
    strokeWidth: 1
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 20,
    textAnchor: "middle",
    fill: "#C8B59B",
    fontSize: 8,
    fontWeight: "bold"
  }, "12")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: 55,
    textAnchor: "middle",
    fill: "#C8B59B",
    fontSize: 8,
    fontWeight: "bold"
  }, "3")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 87,
    textAnchor: "middle",
    fill: "#C8B59B",
    fontSize: 8,
    fontWeight: "bold"
  }, "6")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 25,
    y: 55,
    textAnchor: "middle",
    fill: "#C8B59B",
    fontSize: 8,
    fontWeight: "bold"
  }, "9")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 50,
    x2: 50,
    y2: 30,
    stroke: "#9EC630",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 50,
    x2: 65,
    y2: 50,
    stroke: "#9EC630",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 3,
    fill: "#9EC630"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock-icon.ecb6a0bf8489d7ea7c07417f903c494a.svg";
export { ForwardRef as ReactComponent };